"use client";

import { GoogleAnalytics } from "@next/third-parties/google";
import { useEffect, useState } from "react";

const COOKIE_CONSENT_KEY = "kinken_cookie_consent";

export default function AnalyticsWrapper({ gaId }: { gaId: string }) {
  const [consentGiven, setConsentGiven] = useState(false);

  useEffect(() => {
    // Check initial state
    const checkConsent = () => {
      const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (parsed.categories?.statistics) {
            setConsentGiven(true);
          }
        } catch (e) {
          // ignore error
        }
      }
    };

    checkConsent();

    // Listen for custom event from CookieConsent
    const handleUpdate = () => checkConsent();
    window.addEventListener("cookie-consent-update", handleUpdate);

    return () => window.removeEventListener("cookie-consent-update", handleUpdate);
  }, []);

  if (!consentGiven) return null;

  return <GoogleAnalytics gaId={gaId} />;
}
